import Content from "../../../components/Content"

const HomeLeaguePage = () => {
    return (
        <Content>
            <p className="text-xl font-semibold text-zinc-700">¡Pronto acá encontrarás noticias referidas a la liga, sus fechas y temporadas!</p>
        </Content>
    )
}

export default HomeLeaguePage